import storeInfo from 'ducks/store'
import { InvoiceType } from './types'

export const getInvoice = () => (): InvoiceType => {
  const { invoice } = storeInfo.store.getState()
  return invoice
}
